import { http } from '@/core/api/';

const apiUrl = 'api/medicalplan';

export const getPlanTypes = () => http.get(`${apiUrl}/planTypes`);
export const get = (sie) => http.get(`${apiUrl}/${sie}`);
export const save = (sie, payload) => http.post(`${apiUrl}/${sie}`, payload);
export const getHistory = (sie, params) =>
  http.get(`${apiUrl}/${sie}/history`, { params });

export const saveConsent = (payload) => http.post(`${apiUrl}/consent`, payload);
export const searchConsent = (params) =>
  http.get(`${apiUrl}/consent`, { params });
export const getConsent = (id) => http.get(`${apiUrl}/consent/${id}`);
export const getConsentByStudent = (studentsieid) =>
  http.get(`${apiUrl}/consent/bystudent/${studentsieid}`);
export const saveMechanism = (consentId, isElectronicSignature) =>
  http.put(`${apiUrl}/consent/mechanism/${consentId}/${isElectronicSignature}`);
export const saveSignedDocument = (payload) =>
  http.post(`${apiUrl}/consent/signed-document`, payload);
export const markSigned = (consentId) =>
  http.put(`${apiUrl}/consent/mark-signed/${consentId}`);
